"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const Form_1 = require("antd/lib/form/Form");
const moment_1 = __importDefault(require("moment/moment"));
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const response_codes_1 = require("../../../assets/constants/response_codes");
const strings_1 = require("../../../assets/strings/strings");
const underline_1 = __importDefault(require("../../../components/underline"));
const user_requests_1 = require("../../../dataSource/user_requests");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const logoutUser_1 = require("../../../utils/logoutUser");
const message_utils_1 = __importDefault(require("../../../utils/message_utils"));
const ChangePassword_1 = __importDefault(require("./components/changePassword/ChangePassword"));
const ConfirmDeleteUser_1 = __importDefault(require("./components/confirmDeleteUser/ConfirmDeleteUser"));
const PersonalInformations_1 = __importDefault(require("./components/personalInformations/PersonalInformations"));
const PrivacyNContact_1 = __importDefault(require("./components/privacyNContact/PrivacyNContact"));
const PerfilStyles_1 = require("./PerfilStyles");
const users_1 = require("../../../utils/users");
const Perfil = ({ actualUser }) => {
    const history = (0, react_router_1.useHistory)();
    const [form] = (0, Form_1.useForm)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const [openedModal, setOpenedModal] = (0, react_1.useState)(false);
    const [deleteUserModal, setDeleteUserModal] = (0, react_1.useState)(false);
    const handleSubmitInformations = () => __awaiter(void 0, void 0, void 0, function* () {
        const landLinePhoneDdi = form.getFieldValue('landLinePhone') ? form.getFieldValue('landLinePhoneDdi') : null;
        const landLinePhoneNumber = form.getFieldValue('landLinePhone') || null;
        const ddi = form.getFieldValue('phoneNumber') ? form.getFieldValue('ddi') : null;
        const phoneNumber = form.getFieldValue('phoneNumber') || null;
        const landLinePhone = landLinePhoneNumber ? `${landLinePhoneDdi}#${landLinePhoneNumber}` : null;
        const telephone = phoneNumber ? `${ddi}#${phoneNumber}` : null;
        const birthDate = form.getFieldValue('birthDate');
        const profile = {
            firstName: form.getFieldValue('firstName'),
            lastName: form.getFieldValue('lastName'),
            birthDate: birthDate ? (0, moment_1.default)(birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
            country: form.getFieldValue('country'),
            state: form.getFieldValue('state'),
            genre: form.getFieldValue('genre'),
            landLinePhone,
            telephone,
            whatsappOffers: form.getFieldValue('offers').includes('whatsapp'),
            allowStoreData: form.getFieldValue('offers').includes('allowStore'),
            emailOffers: form.getFieldValue('offers').includes('email'),
            email: actualUser.email,
        };
        const response = yield (0, user_requests_1.editMyProfile)(profile);
        if (response.code === response_codes_1.EditMyProfileCodes.success.PROFILE_UPDATED) {
            (0, users_1.setUserData)(response.currentUser);
            message_utils_1.default.success({ message: strings_1.EditMyProfileMessages.dataUpdatedSuccessfully });
        }
        else {
            switch (response.code) {
                case response_codes_1.GetMyProfileCodes.UNAUTHORIZED:
                    (0, logoutUser_1.handleLogout)(history, RoutesPaths_1.routesPaths.login);
                    message_utils_1.default.error({ message: 'Sessão Expirada' });
                    break;
                default:
                    message_utils_1.default.error();
                    break;
            }
        }
    });
    return (react_1.default.createElement(PerfilStyles_1.Container, null,
        react_1.default.createElement(PerfilStyles_1.Text, { id: "title", size: 48 },
            "Informa\u00E7\u00F5es",
            react_1.default.createElement(PerfilStyles_1.Text, { size: 48, decoration: "bold" }, ` Pessoais`)),
        react_1.default.createElement(underline_1.default, { id: "underline", style: { marginLeft: '32px', marginBottom: '30px' } }),
        react_1.default.createElement(antd_1.Form, { form: form, style: { display: 'flex', flexDirection: 'column', marginTop: '10px' } },
            react_1.default.createElement(PersonalInformations_1.default, { form: form, user: actualUser, open: open, setOpen: setOpen }),
            react_1.default.createElement(PrivacyNContact_1.default, { form: form, user: actualUser })),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { id: "password-section" },
            react_1.default.createElement(PerfilStyles_1.Text, { size: 26, decoration: "500" }, "Senha"),
            react_1.default.createElement("div", null,
                react_1.default.createElement(PerfilStyles_1.Text, null, "Deseja alterar a sua senha? "),
                react_1.default.createElement(PerfilStyles_1.Text, { color: "#c31c4a", onClick: () => setOpenedModal(true), style: { cursor: 'pointer' } }, "Crie uma senha nova"),
                react_1.default.createElement(PerfilStyles_1.Text, null, ` e a mantenha em segredo! :)`)),
            react_1.default.createElement("div", { className: "mobile-order" },
                react_1.default.createElement("div", { className: "delete-account" },
                    react_1.default.createElement(PerfilStyles_1.Text, null, "Quer excluir a sua conta 360 Su\u00EDtes? "),
                    react_1.default.createElement(PerfilStyles_1.Text, { color: "#c31c4a", style: { marginLeft: '30px', cursor: 'pointer' }, onClick: () => setDeleteUserModal(true) }, "Excluir conta")),
                react_1.default.createElement(antd_1.Row, { justify: "end", style: { margin: '10px 0' } },
                    react_1.default.createElement(antd_1.Button, { size: "large", type: "primary", style: {
                            textAlign: 'center',
                            marginLeft: '10px',
                            borderRadius: '5px',
                        }, onClick: handleSubmitInformations }, "Salvar")))),
        react_1.default.createElement(antd_1.Modal, { visible: openedModal, footer: null, centered: true, closable: false },
            react_1.default.createElement(ChangePassword_1.default, { close: () => setOpenedModal(false) })),
        react_1.default.createElement(antd_1.Modal, { visible: deleteUserModal, footer: null, centered: true, closable: false },
            react_1.default.createElement(ConfirmDeleteUser_1.default, { close: () => setDeleteUserModal(false) }))));
};
exports.default = Perfil;
